<template lang="html">
  <div class="" v-if="startup">
    <div v-if="startup.company_type">
      <RealStartupInfoTab :startup="startup" v-if="startup.company_type.value.toUpperCase() == 'STARTUP'" />
      <RealNonStartupInfoTab :startup="startup" v-else />
    </div>
  </div>
</template>

<script>
import RealNonStartupInfoTab from '@/components/RealNonStartupInfoTab.vue'
import RealStartupInfoTab from '@/components/RealStartupInfoTab.vue'
export default {
  name : "StartupInfoTab",
  props: ["startup",'isRestrict'],
  components: {
    RealNonStartupInfoTab,
    RealStartupInfoTab
  },
  data() {
    return {
      apiUrl: process.env.VUE_APP_API_URL,
      tab :null,
    }
  },
  methods:{
    isThereFounders(f){
      if(f == null){
        return false;
      }
      else if(f.length > 0){
        return true;
      }
      else{
        return false;
      }
    },
    founderLink: function(link){
      if(link){
        if(link.startsWith("https://")){
          return link;
        }
        else{
          return "https://"+link;
        }
      }
      else{
        return null;
      }

    },
    getBaseUrl(u){
      if(u){
        var formated = u.replace(/^https?:\/\//, '').replace(/\/$/, '');
        try{
          var r= new URL(u).origin;
          r = r.replace(/^https?:\/\//, '').replace(/\/$/, '');
          return r;
        }catch{
          return formated;
        }
      }
      else{
        return "";
      }

    },
  }
}
</script>

<style lang="css" scoped>
.startup_page{
  padding-top:50px;
  padding-bottom: 50px;
  padding: 50px;
}
.content_div{
  /* margin-top:50px;
  margin-bottom: 50px; */
  padding: 50px;
  padding-bottom:20px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-radius: 8px;
position:relative;
}

.needHelp{
  position:absolute;
  top:20px;
  right:50px;
  color:#B38D2F;
  cursor: pointer;
  border:1px solid #B38D2F;
  border-radius:20px;
  padding: 5px 20px;
  display:inline-block;
}

@media screen and (max-width:690px){
  .needHelp{
    position:relative;
    top:auto;
    right:auto;
    color:#B38D2F;
    margin-bottom:25px;
  }

}
.startup_name{
  color: #3783C5;
text-transform: uppercase;
font-size:24px;
line-height: 29px;
}
.startup_website{
margin-top: 10px;

}
.startup_website a{
  font-size:16px;
  line-height: 22px;
  text-decoration: none;
  color: #000;

}
.startup_website img{
  margin-right: 10px;
}
.startup_banner{

  position:relative;
  height:300px;
  background:#EFEFEF;
  padding: 0 !important;
}
.startup_banner img{
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.changeImage{
  position:absolute;
  top:15px;
  right:30px;
  font-size:12px;
  line-height: 12px;
  color:#000;
  background:#FFF;
  border-radius:50%;;
  padding: 10px;

}
.changeImageLogo{
  position:absolute;
  top:0px;
  right:0px;
  font-size:12px;
  line-height: 12px;
  color:#000;
  background:#FFF;
  border-radius:50%;;
  padding: 10px;

}
.assessment{
  margin-top:100px;
  margin-bottom: 100px;
}
.item_card{
  border: 1px solid #DDD;
  border-radius: 10px;
padding: 20px;
position:relative;
padding-top: 40px;
margin-top: 20px;
}
.item_card .item_card_title{
  position:absolute;
  top: 0px;
  transform: translateY(-50%);
  left: 20px;
  background: #FFF;
  color: #3783C5;
text-transform: uppercase;
font-size:18px;
line-height: 24px;
  padding-left: 20px;
  padding-right: 20px;
}






.barcontainer{
  background-color: #DDDDDD;
  position: relative;
  margin-left: 50px;
  width: 30px;
  height: 200px;
}
.bar{
  background-color: #3783C5;
  position: absolute;
  bottom: 0;
  width: 100%;

  box-sizing: border-box;
  -webkit-transition: all 0.5s linear;
      -moz-transition: all 0.5s linear;
      -o-transition: all 0.5s linear;
      transition: all 0.5s linear;
  transform-origin: bottom;
}
.bar.low{
  height: 10%;
}
.bar.medium{
  height: 50%;
}

.bar.high{
  height: 90%;

}

@keyframes grow{
  from{
    transform: scaleY(0);
  }
}

.jauge_label.low{
  position: absolute;
  bottom :10%;
  transform: translateY(50%);
  right: -210px;
  width: 200px;
  padding-left: 10px;
  display: flex;
  align-items: center;
}

.jauge_label.medium{
  position: absolute;
  bottom :50%;
  transform: translateY(50%);
  right: -210px;
  width: 200px;
  padding-left: 10px;
  display: flex;
  align-items: center;
}


.jauge_label.high{
  position: absolute;
  top :10%;
  transform: translateY(-50%);
  right: -210px;
  width: 200px;
  padding-left: 10px;
  display: flex;
  align-items: center;
}

.jauge_label::before{
  content :" ";
  background: #707070;
  width:10px;
  height:1px;
  left: -10px;
  position:absolute;
  top: 50%;
}
.jauge_label input{
  width:22px;
  height:22px;
}

.jauge_label span{
  display:block;
  color: #3783C5;
  font-size: 14px;
  line-height: 22px;
  width:100%;
  font-weight: 500;
  text-transform:uppercase;
}
.jauge_label small{
  color: #575757;
  font-weight: 300;
  font-size:14px;
  line-height: 22px;
}
.info{
    display: flex;
    flex-direction: column;
    padding: 5px;
}

.flex{
  display:flex;
  align-items: center;
    gap: 20px;
}
.barLabel{
  color: #3783C5;
  font-size:18px;
  line-height: 21px;
}
@media screen and (max-width:1200px){
  .flex{
    flex-direction: column;

    align-items: flex-start;
  }
}

.rocker input{
  display: none;
}
.rocker{
  border: 1px solid #3783C5;
border-radius: 50px;padding:5px;
}
.rocker .switch-left{
  padding:5px 30px;
  text-align:center;
  display:inline-block;
  font-size:14px;
  line-height:22px;
  cursor: pointer;
    color:#3783C5;
}
.rocker .switch-right{
  padding:5px 30px;
  text-align:center;
  display:inline-block;
  font-size:14px;
  line-height:22px;
  cursor: pointer;
    color:#3783C5;
}
.rocker input:checked + .switch-left {
  background:#3783C5;
  color: #FFF;
  border-radius: 50px 0 0 50px;
}
.rocker input:not(:checked)+ .switch-left  + .switch-right {
  background:#3783C5;
  color: #FFF;
  border-radius: 0 50px 50px 0  ;
}

.center{
  align-items: center;
}

.mt50{
  margin-top: 50px;
}
.mb50{
  margin-bottom: 50px;
}

.divider-dotted{
  border-bottom:1px dashed #3783C5;
}

.next_step_btn{
  background: #3783C5 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#FFF;
  margin:5px;

}
.next_step_btn img.left{
  margin-right:10px;
}

.prev_step_btn{
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#3783C5;
  margin:5px;
}
.prev_step_btn img{
  margin-right:10px;
}

.prev_step_btn{
  text-decoration :none;
}
.contact_step_btn{
  border: 1px solid #575757;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#FFF;
  background:#575757;
  margin:5px;
  text-decoration: none;
}

@media screen and (max-width: 690px){
  .startup_page{
    padding-left:15px;
    padding-right: 15px;
  }
  .content_div{
    padding-right: 20px;
    padding-left: 20px;
  }
}



.info_startup{
  display:flex;
gap: 10px;
/* border-bottom: 1px solid #DDD; */
padding-bottom: 10px;
padding-top: 10px;
flex-direction: column;
}


.info_startup_1{
  width: 100%;
  display:flex;
  flex-direction: column;
}
.info_startup_2{
  width: 100%;
  display:block;
}

.fullW .info_startup_1{
    width: 50%;
  }
.fullW .info_startup_2{
    width: 50%;
      display:block;
}
.info_startup.large_col1 .info_startup_1,
.info_startup.large_col1 .info_startup_2{
  width:50%;
    display:block;
}

@media screen and (max-width: 690px){
  .info_startup{
    flex-direction: column;
  }
  .info_startup_1,
  .info_startup_2{
    width:100%;
      display:block;
  }
}
.info_startup_1 .info_name{
font-size: 12px;
line-height: 15px;
color: #3783C5;
text-transform: uppercase;
font-weight: 700;
}
.info_startup_1 .info_name.innopearl_purple{
  color: #6C68A2;
}
.info_startup_2 .info_value{
  font-size:16px;
  line-height: 22px;
  width: 100%;
  resize-x:none;
}

.startup_founders{
  list-style-type: none;
  padding-left: 0;
  margin-bottom: 0px;
}
.founder{
  font-size: 16px;
  line-height: 28px;
  margin-left:0px;
  padding-left:0px;
}
.founder .picto_link_linkedin{
  margin-left:20px;
}
.info_value{
white-space: pre-wrap
}

.info_value_investment{
  width:auto !important;
  display:inline-block;
  max-width: 100px;
}

.selectDevise{
  border:1px solid #CCC;
  -webkit-appearance: auto;
  -moz-appearance :auto;
  padding:5px;
  max-width: 50px;
}

input,textarea{
  border-bottom: 1px solid #B38D2F;
  padding:5px;
}

.add_custom_key_factor button{
  font-size:12px;
  color:#FFF;
  background: #3783C5;
  border-radius:200px;
  padding:5px 10px;
}
button.error{
  background: red;
  padding:5px;
  width:25px;
  height:25px;
  font-size:15px;
  line-height: 15px;
  border-radius:50%;
  color:#FFF;
}
.add_founder{
  margin-top:10px;
}

.selectDevise{
  -moz-appearance: button;
  padding: 5px;
  max-width: 50px;
  border-bottom: 1px solid #B38D2F;
  font-size: 16px;
  line-height: 22px;
  margin-left: 5px;
}

.jauge_label{
  text-align:left !important;
}

.padding20{
  padding:20px;
}





.bussiness_challenge_stepper{
  display: flex;
  gap: 20px;
  justify-content: center;

}
.bussiness_challenge_stepper .step{
  border-bottom: 1px solid #ADB3B5;
  position : relative;
  flex: 1;
  text-align: center;
  padding: 10px;
}
.bussiness_challenge_stepper .step.active{
    border-bottom: 2px solid #3783C5;
}
.bussiness_challenge_stepper .active:after{
  content: '';
position: absolute;
left: calc(50% - 15px);
top: 100%;
width: 0;
height: 0;
border-left: 15px solid transparent;
border-right: 15px solid transparent;
border-top: 15px solid #3783C5;
clear: both;
}
.bussiness_challenge_stepper .stepNumber{
  font-size: 36px;
  line-height: 44px;
  letter-spacing: 0px;
  color: #ADB3B5;
}
.bussiness_challenge_stepper .stepName{
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0px;
  color: #ADB3B5;
}
.bussiness_challenge_stepper .active .stepNumber,
.bussiness_challenge_stepper .active .stepName
{
  color: #3783C5;
}
.ptb50{
  padding-top:50px;
  padding-bottom: 50px;
}

.rowinside{
  display:flex;
  flex-direction: row;
  flex-wrap: wrap;
  row-gap:20px;
  justify-content: center;
  align-items: flex-start;
    align-self: flex-start;
    align-content: flex-start;
}

.col-in{
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-left:20px;
  padding-right: 20px;
  justify-content: center;
}

textarea{
  width:100% !important;
}

.requi{
  font-size:20px;
  color:red;
}
sup{
  top:0 !important;
}

.table_brief_doc thead td{
  background: #EEE;
  padding-top:10px;
  padding-bottom:10px;
}
.table_brief_doc tbody{
  border:1px solid #EEE;
}
.table_brief_doc a{
  color: inherit;
}
.table_brief_doc svg{
  color: #3783C5
}



.zone_input_checkboxes{
  margin-left: 65px;
  width: calc(100% - 65px);
  display: flex;
  margin-top:20px;
  gap: 20px;
  flex-wrap: wrap;
}

.partnership_objectives_label{
  padding:12px 30px;
  background: #EFEFEF 0% 0% no-repeat padding-box;
border-radius: 3px;
min-width: calc(20% - 20px);
max-width: calc(20% - 20px);
flex-basis: 0;
flex: 1;
display:flex;
flex-direction: column;
gap: 10px;
border: 1px solid #EFEFEF;
}

@media screen and (max-width: 990px){
  .partnership_objectives_label{
    min-width: calc(50% - 20px);
    max-width: calc(50% - 20px);
  }
}

@media screen and (max-width: 690px){
  .partnership_objectives_label{
    min-width: calc(100% - 20px);
    max-width: calc(100% - 20px);
  }
}
input[type='checkbox']{
  width: 24px;
height: 24px;
margin-top:auto;
}
.checkbox_container{
  width:100%;
  display:block;
  text-align: right;
  align-self: end;
margin-top: auto;
}
.partnership_objectives_label.add_other_objectif{
background:#FFF;
}
.add_other_objectif input{
  border:1px solid #EFEFEF;
  padding: 5px;
}
.checkbox_container button{
  font-size: 18px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
}

.rocker input{
  display: none;
}
.rocker{
  border: 1px solid #3783C5;
border-radius: 50px;padding:5px;
}
.rocker .switch-left{
  padding:5px 30px;
  text-align:center;
  display:inline-block;
  font-size:14px;
  line-height:22px;
  cursor: pointer;
    color:#3783C5;
}
.rocker .switch-right{
  padding:5px 30px;
  text-align:center;
  display:inline-block;
  font-size:14px;
  line-height:22px;
  cursor: pointer;
    color:#3783C5;
}
.rocker input:checked + .switch-left {
  background:#3783C5;
  color: #FFF;
  border-radius: 50px 0 0 50px;
}
.rocker input:not(:checked)+ .switch-left  + .switch-right {
  background:#3783C5;
  color: #FFF;
  border-radius: 0 50px 50px 0  ;
}


.checkbox-wrapper-21 .control {
  display: block;
  position: relative;
  padding-left: 30px;
  cursor: pointer;
  font-size: 18px;
}
.checkbox-wrapper-21 .control input {
  position: absolute;
  z-index: -1;
  opacity: 0;
}
.checkbox-wrapper-21 .control__indicator {
  position: absolute;
  top: 2px;
  left: 0;
  height: 25px;
  width: 25px;
  background: #FFF;
  border:1px solid #3783C5;
}
.checkbox-wrapper-21 .control:hover input ~ .control__indicator,
.checkbox-wrapper-21 .control input:focus ~ .control__indicator {
  background: #FFF;
}
.checkbox-wrapper-21 .control input:checked ~ .control__indicator {
  background: #3783C5;
}
.checkbox-wrapper-21 .control:hover input:not([disabled]):checked ~ .control__indicator,
.checkbox-wrapper-21 .control input:checked:focus ~ .control__indicator {
  background: #3783C5;
}
.checkbox-wrapper-21 .control input:disabled ~ .control__indicator {
  background: #e6e6e6;
  opacity: 0.6;
  pointer-events: none;
}
.checkbox-wrapper-21 .control__indicator:after {
  content: '';
  position: absolute;
  display: none;
}
.checkbox-wrapper-21 .control input:checked ~ .control__indicator:after {
  display: block;
}
.checkbox-wrapper-21 .control--checkbox .control__indicator:after {
  left: 10px;
    top: 5px;
    width: 7px;
    height: 12px;
    border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
.checkbox-wrapper-21 .control--checkbox input:disabled ~ .control__indicator:after {
  border-color: #7b7b7b;
}

.successMessage{
  padding:50px;
  border:2px solid #3783C5;
}
.successMessage .thankyou1{
  display:block;
  text-align: center;
  font-size:25px;
  text-transform: uppercase;
  color:#3783C5;
  font-weight: 700;
}

.successMessage .thankyou2{
  display:block;
  text-align: center;
  font-size:20px;
  text-transform: uppercase;
  color:#3783C5;
}


.dflex{
  display:flex;
  justify-content: flex-start;
}
.has-addons{
  display: flex;
  gap: 0;
  border: 1px solid #CCC;
  border-radius: 20px;
}
#copyToClipboard{
  background: #3783C5;
  color: #FFF;
  padding: 15px 20px;
  border-radius: 0px 20px 20px 0px;
    cursor:pointer;
}
#copyToClipboardContent{
padding: 10px;
cursor:pointer;

}

#copyToClipboardContent input{
  width: auto;
  display: block;
  cursor:pointer;
  border:none;
  min-width: 450px;
}


.footer{
  padding:10px;text-align:center;
}
.footer small{
  display:block;
}
.footer a{
  color:inherit;
}
.headerStartup{
  position:relative;
}
.mt100{
  padding-top:120px;
}
.startup_logo{
  width: 300px;
    height: 150px;
    position: absolute;
    left: 50px;
    bottom: -75px;
    z-index: 999;

}
.startup_logo img{
  width: 300px;
    height: 150px;
    object-fit: contain;
    padding:10px;
}
.startup_logo .alt{
  width: 300px;
    height: 150px;

}
.startup_logo_inside{
  position:relative;
  -webkit-box-shadow: 0px 0px 20px -4px #CCC;
  box-shadow:0px 0px 20px -4px #CCC;
  background:#FFF;
}

.partialInfo{
  position: absolute;
  top: 0;
  background: #df7c2a;
  color: #FFF;
  z-index: 900;
  padding: 10px 20px;
  left: 50%;
  transform: translateX(-50%);
  max-width:80%;
  font-size:20px;
  text-align:center;
}

.tblue{
    color: #4C81C0 !important;
}
.contactZone{
  border:2px solid #4C81C0;
  border-radius: 10px;
  padding:20px 50px;
  width:auto;
  position:relative;
}
.editContact{
  position:absolute;
  top:10px;
  right:10px;
}
@media screen and (max-width:1000px){
  .contactZone{
    margin-top:20px;
  }
}
.contactZone h5{
  display:block;
  color: #4C81C0 !important;
}
.contactInfo{
  display: flex;
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
  color: #4C81C0 !important;
  font-weight: 600;
}
.contactInfo{
  display: flex;
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
  color: #000 !important;
  font-weight: 600;
}

.contactInfo a,
.contactInfo a:hover{
  color: #000 !important;
  font-weight: normal;

}

.editField{
  color:#000;
  margin-left:10px;
}

.grid{
  display:grid;
  grid-template-columns: 1fr 1fr;
  gap : 10px 20px;
}

@media screen and (max-width:990px){

  .grid{
    display:grid;
    grid-template-columns: 1fr;
    gap : 10px 20px;
  }
}

.insideTab{
  min-height:100px;
}

.listIt{
  display:flex;
  flex-direction: column;
}

.startup_banner .fallbackBanner{
  width: 100%;
  height: 100%;
  background:#EFEFEF;
}

#bannerUp{
  display: none;
}

#logoUp{
  display: none;
}

.uploadProceedBanner{
  position: absolute;
    top: 0;
    left: 0;
    transform: none;
    background: rgba(255,255,255,0.9);
    padding: 20px;
    bottom: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-content: center;
}
.uploadProceedBanner .uploadProcess{
  width:80%;
}


.pl20{
  padding-left:20px !important;
}
@media screen and (max-width:890px){
.listOfContacts .dflex{
  flex-direction: column;
  border-bottom:1px solid #000;
}
.listOfContacts .dflex .text-right{
  text-align:left !important;
}
.listOfContacts td{
  border:none;
}
}

.fallbackBanner_size{
  font-size: 40px;
  color: #CCC;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}



.startup_name{
  color: #3783C5;
text-transform: uppercase;
font-size:24px;
line-height: 29px;
}
.startup_website{
margin-top: 10px;

}
.startup_website a{
  font-size:16px;
  line-height: 22px;
  text-decoration: none;
  color: #000;

}
.startup_website img{
  margin-right: 10px;
}
.startup_banner{

  position:relative;
  height:300px;
  background:#fff;
  padding: 0 !important;
}
.startup_banner img{
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.changeImage{
  position:absolute;
  top:15px;
  right:30px;
  font-size:12px;
  line-height: 12px;
  color:#000;
  background:#FFF;
  border-radius:50%;;
  padding: 10px;

}
.changeImageLogo{
  position:absolute;
  top:0px;
  right:0px;
  font-size:12px;
  line-height: 12px;
  color:#000;
  background:#FFF;
  border-radius:50%;;
  padding: 10px;

}
.assessment{
  margin-top:100px;
  margin-bottom: 100px;
}
.item_card{
  border: 1px solid #DDD;
  border-radius: 10px;
padding: 20px;
position:relative;
padding-top: 40px;
margin-top: 20px;
}
.item_card .item_card_title{
  position:absolute;
  top: 0px;
  transform: translateY(-50%);
  left: 20px;
  background: #FFF;
  color: #3783C5;
text-transform: uppercase;
font-size:18px;
line-height: 24px;
  padding-left: 20px;
  padding-right: 20px;
}






.barcontainer{
  background-color: #DDDDDD;
  position: relative;
  margin-left: 50px;
  width: 30px;
  height: 200px;
}
.bar{
  background-color: #3783C5;
  position: absolute;
  bottom: 0;
  width: 100%;

  box-sizing: border-box;
  -webkit-transition: all 0.5s linear;
      -moz-transition: all 0.5s linear;
      -o-transition: all 0.5s linear;
      transition: all 0.5s linear;
  transform-origin: bottom;
}
.bar.low{
  height: 10%;
}
.bar.medium{
  height: 50%;
}

.bar.high{
  height: 90%;

}

@keyframes grow{
  from{
    transform: scaleY(0);
  }
}

.jauge_label.low{
  position: absolute;
  bottom :10%;
  transform: translateY(50%);
  right: -210px;
  width: 200px;
  padding-left: 10px;
  display: flex;
  align-items: center;
}

.jauge_label.medium{
  position: absolute;
  bottom :50%;
  transform: translateY(50%);
  right: -210px;
  width: 200px;
  padding-left: 10px;
  display: flex;
  align-items: center;
}


.jauge_label.high{
  position: absolute;
  top :10%;
  transform: translateY(-50%);
  right: -210px;
  width: 200px;
  padding-left: 10px;
  display: flex;
  align-items: center;
}

.jauge_label::before{
  content :" ";
  background: #707070;
  width:10px;
  height:1px;
  left: -10px;
  position:absolute;
  top: 50%;
}
.jauge_label input{
  width:22px;
  height:22px;
}

.jauge_label span{
  display:block;
  color: #3783C5;
  font-size: 14px;
  line-height: 22px;
  width:100%;
  font-weight: 500;
  text-transform:uppercase;
}
.jauge_label small{
  color: #575757;
  font-weight: 300;
  font-size:14px;
  line-height: 22px;
}
.info{
    display: flex;
    flex-direction: column;
    padding: 5px;
}

.flex{
  display:flex;
  align-items: center;
    gap: 20px;
}
.barLabel{
  color: #3783C5;
  font-size:18px;
  line-height: 21px;
}
@media screen and (max-width:1200px){
  .flex{
    flex-direction: column;

    align-items: flex-start;
  }
}

.rocker input{
  display: none;
}
.rocker{
  border: 1px solid #3783C5;
border-radius: 50px;padding:5px;
}
.rocker .switch-left{
  padding:5px 30px;
  text-align:center;
  display:inline-block;
  font-size:14px;
  line-height:22px;
  cursor: pointer;
    color:#3783C5;
}
.rocker .switch-right{
  padding:5px 30px;
  text-align:center;
  display:inline-block;
  font-size:14px;
  line-height:22px;
  cursor: pointer;
    color:#3783C5;
}
.rocker input:checked + .switch-left {
  background:#3783C5;
  color: #FFF;
  border-radius: 50px 0 0 50px;
}
.rocker input:not(:checked)+ .switch-left  + .switch-right {
  background:#3783C5;
  color: #FFF;
  border-radius: 0 50px 50px 0  ;
}

.center{
  align-items: center;
}

.mt50{
  margin-top: 50px;
}
.mb50{
  margin-bottom: 50px;
}

.divider-dotted{
  border-bottom:1px dashed #3783C5;
}

.next_step_btn{
  background: #3783C5 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#FFF;
  margin:5px;

}
.next_step_btn img.left{
  margin-right:10px;
}

.prev_step_btn{
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#3783C5;
  margin:5px;
}
.prev_step_btn img{
  margin-right:10px;
}

.prev_step_btn{
  text-decoration :none;
}
.contact_step_btn{
  border: 1px solid #575757;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#FFF;
  background:#575757;
  margin:5px;
  text-decoration: none;
}

@media screen and (max-width: 690px){
  .startup_page{
    padding-left:15px;
    padding-right: 15px;
  }
  .content_div{
    padding-right: 20px;
    padding-left: 20px;
  }
}



.info_startup{
  display:flex;
gap: 10px;
/* border-bottom: 1px solid #DDD; */
padding-bottom: 10px;
padding-top: 10px;
flex-direction: column;
}


.info_startup_1{
  width: 100%;
  display:flex;
  flex-direction: column;
}
.info_startup_2{
  width: 100%;
  display:block;
}

.fullW .info_startup_1{
    width: 50%;
  }
.fullW .info_startup_2{
    width: 50%;
      display:block;
}
.info_startup.large_col1 .info_startup_1,
.info_startup.large_col1 .info_startup_2{
  width:50%;
    display:block;
}

@media screen and (max-width: 690px){
  .info_startup{
    flex-direction: column;
  }
  .info_startup_1,
  .info_startup_2{
    width:100%;
      display:block;
  }
}
.info_startup_1 .info_name{
font-size: 12px;
line-height: 15px;
color: #000;
text-transform: uppercase;
font-weight: 700;
}
.info_startup_1 .info_name.innopearl_purple{
  color: #6C68A2;
}
.info_startup_2 .info_value{
  font-size:16px;
  line-height: 22px;
  width: 100%;
  resize-x:none;
}

.startup_founders{
  list-style-type: none;
  padding-left: 0;
  margin-bottom: 0px;
}
.founder{
  font-size: 16px;
  line-height: 28px;
  margin-left:0px;
  padding-left:0px;
}
.founder .picto_link_linkedin{
  margin-left:20px;
}
.info_value{
white-space: pre-wrap
}

.info_value_investment{
  width:auto !important;
  display:inline-block;
  max-width: 100px;
}

.selectDevise{
  border:1px solid #CCC;
  -webkit-appearance: auto;
  -moz-appearance :auto;
  padding:5px;
  max-width: 50px;
}

input,textarea{
  border-bottom: 1px solid #B38D2F;
  padding:5px;
}

.add_custom_key_factor button{
  font-size:12px;
  color:#FFF;
  background: #3783C5;
  border-radius:200px;
  padding:5px 10px;
}
button.error{
  background: red;
  padding:5px;
  width:25px;
  height:25px;
  font-size:15px;
  line-height: 15px;
  border-radius:50%;
  color:#FFF;
}
.add_founder{
  margin-top:10px;
}

.selectDevise{
  -moz-appearance: button;
  padding: 5px;
  max-width: 50px;
  border-bottom: 1px solid #B38D2F;
  font-size: 16px;
  line-height: 22px;
  margin-left: 5px;
}

.jauge_label{
  text-align:left !important;
}

.padding20{
  padding:20px;
}





.bussiness_challenge_stepper{
  display: flex;
  gap: 20px;
  justify-content: center;

}
.bussiness_challenge_stepper .step{
  border-bottom: 1px solid #ADB3B5;
  position : relative;
  flex: 1;
  text-align: center;
  padding: 10px;
}
.bussiness_challenge_stepper .step.active{
    border-bottom: 2px solid #3783C5;
}
.bussiness_challenge_stepper .active:after{
  content: '';
position: absolute;
left: calc(50% - 15px);
top: 100%;
width: 0;
height: 0;
border-left: 15px solid transparent;
border-right: 15px solid transparent;
border-top: 15px solid #3783C5;
clear: both;
}
.bussiness_challenge_stepper .stepNumber{
  font-size: 36px;
  line-height: 44px;
  letter-spacing: 0px;
  color: #ADB3B5;
}
.bussiness_challenge_stepper .stepName{
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0px;
  color: #ADB3B5;
}
.bussiness_challenge_stepper .active .stepNumber,
.bussiness_challenge_stepper .active .stepName
{
  color: #3783C5;
}
.ptb50{
  padding-top:50px;
  padding-bottom: 50px;
}

.rowinside{
  display:flex;
  flex-direction: row;
  flex-wrap: wrap;
  row-gap:20px;
  justify-content: center;
  align-items: flex-start;
    align-self: flex-start;
    align-content: flex-start;
}

.col-in{
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-left:20px;
  padding-right: 20px;
  justify-content: center;
}

textarea{
  width:100% !important;
}

.requi{
  font-size:20px;
  color:red;
}
sup{
  top:0 !important;
}

.table_brief_doc thead td{
  background: #EEE;
  padding-top:10px;
  padding-bottom:10px;
}
.table_brief_doc tbody{
  border:1px solid #EEE;
}
.table_brief_doc a{
  color: inherit;
}
.table_brief_doc svg{
  color: #3783C5
}



.zone_input_checkboxes{
  margin-left: 65px;
  width: calc(100% - 65px);
  display: flex;
  margin-top:20px;
  gap: 20px;
  flex-wrap: wrap;
}

.partnership_objectives_label{
  padding:12px 30px;
  background: #EFEFEF 0% 0% no-repeat padding-box;
border-radius: 3px;
min-width: calc(20% - 20px);
max-width: calc(20% - 20px);
flex-basis: 0;
flex: 1;
display:flex;
flex-direction: column;
gap: 10px;
border: 1px solid #EFEFEF;
}

@media screen and (max-width: 990px){
  .partnership_objectives_label{
    min-width: calc(50% - 20px);
    max-width: calc(50% - 20px);
  }
}

@media screen and (max-width: 690px){
  .partnership_objectives_label{
    min-width: calc(100% - 20px);
    max-width: calc(100% - 20px);
  }
}
input[type='checkbox']{
  width: 24px;
height: 24px;
margin-top:auto;
}
.checkbox_container{
  width:100%;
  display:block;
  text-align: right;
  align-self: end;
margin-top: auto;
}
.partnership_objectives_label.add_other_objectif{
background:#FFF;
}
.add_other_objectif input{
  border:1px solid #EFEFEF;
  padding: 5px;
}
.checkbox_container button{
  font-size: 18px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
}

.rocker input{
  display: none;
}
.rocker{
  border: 1px solid #3783C5;
border-radius: 50px;padding:5px;
}
.rocker .switch-left{
  padding:5px 30px;
  text-align:center;
  display:inline-block;
  font-size:14px;
  line-height:22px;
  cursor: pointer;
    color:#3783C5;
}
.rocker .switch-right{
  padding:5px 30px;
  text-align:center;
  display:inline-block;
  font-size:14px;
  line-height:22px;
  cursor: pointer;
    color:#3783C5;
}
.rocker input:checked + .switch-left {
  background:#3783C5;
  color: #FFF;
  border-radius: 50px 0 0 50px;
}
.rocker input:not(:checked)+ .switch-left  + .switch-right {
  background:#3783C5;
  color: #FFF;
  border-radius: 0 50px 50px 0  ;
}


.checkbox-wrapper-21 .control {
  display: block;
  position: relative;
  padding-left: 30px;
  cursor: pointer;
  font-size: 18px;
}
.checkbox-wrapper-21 .control input {
  position: absolute;
  z-index: -1;
  opacity: 0;
}
.checkbox-wrapper-21 .control__indicator {
  position: absolute;
  top: 2px;
  left: 0;
  height: 25px;
  width: 25px;
  background: #FFF;
  border:1px solid #3783C5;
}
.checkbox-wrapper-21 .control:hover input ~ .control__indicator,
.checkbox-wrapper-21 .control input:focus ~ .control__indicator {
  background: #FFF;
}
.checkbox-wrapper-21 .control input:checked ~ .control__indicator {
  background: #3783C5;
}
.checkbox-wrapper-21 .control:hover input:not([disabled]):checked ~ .control__indicator,
.checkbox-wrapper-21 .control input:checked:focus ~ .control__indicator {
  background: #3783C5;
}
.checkbox-wrapper-21 .control input:disabled ~ .control__indicator {
  background: #e6e6e6;
  opacity: 0.6;
  pointer-events: none;
}
.checkbox-wrapper-21 .control__indicator:after {
  content: '';
  position: absolute;
  display: none;
}
.checkbox-wrapper-21 .control input:checked ~ .control__indicator:after {
  display: block;
}
.checkbox-wrapper-21 .control--checkbox .control__indicator:after {
  left: 10px;
    top: 5px;
    width: 7px;
    height: 12px;
    border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
.checkbox-wrapper-21 .control--checkbox input:disabled ~ .control__indicator:after {
  border-color: #7b7b7b;
}

.successMessage{
  padding:50px;
  border:2px solid #3783C5;
}
.successMessage .thankyou1{
  display:block;
  text-align: center;
  font-size:25px;
  text-transform: uppercase;
  color:#3783C5;
  font-weight: 700;
}

.successMessage .thankyou2{
  display:block;
  text-align: center;
  font-size:20px;
  text-transform: uppercase;
  color:#3783C5;
}


.dflex{
  display:flex;
  justify-content: flex-start;
}
.has-addons{
  display: flex;
  gap: 0;
  border: 1px solid #CCC;
  border-radius: 20px;
}
#copyToClipboard{
  background: #3783C5;
  color: #FFF;
  padding: 15px 20px;
  border-radius: 0px 20px 20px 0px;
    cursor:pointer;
}
#copyToClipboardContent{
padding: 10px;
cursor:pointer;

}

#copyToClipboardContent input{
  width: auto;
  display: block;
  cursor:pointer;
  border:none;
  min-width: 450px;
}


.footer{
  margin-top:40px;
  padding:10px;text-align:center;
}
.footer small{
  display:block;
}
.footer a{
  color:inherit;
}

  .footerAbs2{
    position:absolute;
    bottom:28px;
    right:20px;
  }

  @media screen and (max-width:990px){
    .footerAbs2{
      position:relative;
      bottom:auto;
      right:auto;
    }
  }
.headerStartup{
  position:relative;
}
.mt100{
  padding-top:120px;
}
.startup_logo{
  width: 300px;
    height: 150px;
    position: absolute;
    left: 50px;
    bottom: -75px;
    z-index: 999;

}
.startup_logo img{
  width: 300px;
    height: 150px;
    object-fit: contain;
    padding:10px;
}
.startup_logo .alt{
  width: 300px;
    height: 150px;

}
.startup_logo_inside{
  position:relative;
  -webkit-box-shadow: 0px 0px 20px -4px #CCC;
  box-shadow:0px 0px 20px -4px #CCC;
  background:#FFF;
}

.partialInfo{
  position: absolute;
  top: 0;
  background: #B38D2F;
  color: #FFF;
  z-index: 900;
  padding: 10px 20px;
  left: 50%;
  transform: translateX(-50%);
  max-width:80%;
  font-size:20px;
  text-align:center;
}

.tblue{
    color: #4C81C0 !important;
}
.tdore{
  color: #B38D2F !important;
}
.contactZone{
  border:2px solid #125AA4;
  background:#125AA4;
  border-radius: 10px;
  padding:20px 20px;
  width:auto;
  position:relative;
}
.editContact{
  position:absolute;
  top:10px;
  right:10px;
}
@media screen and (max-width:1000px){
  .contactZone{
    margin-top:20px;
  }
}
.contactZone h5{
  display: block;
  color: #fff !important;
  margin-bottom: 0;
  font-size:22px;
}
.contactInfo{
  display: flex;
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
  color: #fff !important;
  font-weight: 600;
}

.contactInfo{
  display: flex;
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
  color: #000 !important;
  font-weight: 600;
}

.contactInfo a,
.contactInfo a:hover{
  color: #000 !important;
  font-weight: normal;
word-wrap: anywhere;
}

.editField{
  color:#000;
  margin-left:10px;
}

.grid{
  display:grid;
  grid-template-columns: 1fr 1fr;
  gap : 10px 20px;
}

@media screen and (max-width:990px){

  .grid{
    display:grid;
    grid-template-columns: 1fr;
    gap : 10px 20px;
  }
}

.insideTab{
  min-height:100px;
}

.listIt{
  display:flex;
  flex-direction: column;
}

.startup_banner .fallbackBanner{
  width: 100%;
  height: 100%;
  background:#EFEFEF;
}

#bannerUp{
  display: none;
}

#logoUp{
  display: none;
}

.uploadProceedBanner{
  position: absolute;
    top: 0;
    left: 0;
    transform: none;
    background: rgba(255,255,255,0.9);
    padding: 20px;
    bottom: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-content: center;
}
.uploadProceedBanner .uploadProcess{
  width:80%;
}


.pl20{
  padding-left:20px !important;
}
@media screen and (max-width:890px){
.listOfContacts .respTable{
  flex-direction: column;
  display:flex;
  border-bottom:1px solid #000;
}

.listOfContacts .respTable .text-right{
  text-align:left !important;
}
.listOfContacts td{
  border:none;
}
}

.fallbackBanner_size{
  font-size: 40px;
  color: #CCC;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}

.fs30{
  font-size:30px;
}

.contactInfoItem{
  color:#B38D2F !important;
}
.contactInfoItem a,
.contactInfoItem a:hover,
.contactInfoItem span
{
  color:#FFF !important;
}
.contactInfo_kcn{
  color:#FFF;
  font-weight: 600;
    font-size:18px;
}

.contactInfoItem{
  margin-bottom: 10px;
}
.mb20{
  margin-bottom: 20px;
}

.contactZone .editContact{
  color:#FFF !important;
}

.dflexcontact{
  display:flex;
  gap:10px;
  align-items: center;
}

.contactIcon i{
  font-size: 30px;
    background: #3584C6;
    padding: 25px;
    color: #FFF;
    border-radius: 50%;
}
.contactInfoItem *{
  word-break:break-all;
}

.fblue{
  background: #3584C6;
    padding: 15px;
    color: #FFF;
    border-radius: 50%;
    margin-right: 10px;
    font-size: 15px;

}
.cmail a,
.cmail a:hover,
.ctel a,
.ctel a:hover{
    color:inherit;
}
.cmail i{
font-size:25px;
border-radius: 50%;
  margin-right: 10px;
}
.mr20{
      margin-right: 10px;
}
.crole{
  margin-left:20px;
}

.clinks{
  display:flex;
  gap:10px;
  justify-content: end;
}

.clinks i{

    background: #fff;
    border:1px solid #3584C6;
      padding: 15px;
      color: #3584C6;
      border-radius: 50%;
      font-size: 20px;


}

@media screen and (min-width:1200px) and (max-width:1700px){
  .force50{
    width:50% !important;
  }
}
@media screen and (max-width:1500px){
  .force100{
    margin-top:60px;
    width:100% !important;
  }
  .revese{
  flex-direction: column-reverse;
  }

}

.cn,
.ctel,
.cmail{
  width:30%;
}

@media screen and (max-width:1500px){
.respTable{
  display:flex;
  flex-direction: column;

}
.respTable td{
  width:100%;
  border:none;
}
.clinks{
  display:flex;
  gap:10px;
}
.respTable td:last-child{
  border-bottom:1px solid #ccc;
}
}

.listOfContacts{
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}
.listOfContacts .contactZone{
  width:calc(33% - 40px);
}

@media screen and (max-width:1500px){
  .listOfContacts .contactZone{
    width:calc(50% - 40px);
  }
}
@media screen and (max-width:990px){
  .listOfContacts .contactZone{
    width:100%;
  }
}
</style>

<style media="screen">
  .v-window{
    border: 1px solid #3783C5;
    margin-bottom:50px;
  }
  .v-tabs{
        background: #115AA4 !important;

  }
  .v-tab--selected{
    background: #3783C5 !important;
  }
  .v-tab__slider{
    display:none;
  }
</style>
